import _ from '@lodash';
import { Avatar, Chip, Icon, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@material-ui/core';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import EmpresaTagNewButton from 'app/ERP/EmpresaTag/EmpresaTagNewButton';
import clsx from 'clsx';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { MdAdd, MdLabel } from 'react-icons/md';
import XAPPButton from '../Button/XAPPButton';

class TagFormulario extends XAPPComponent {

    state = {
        tagMenuEl: null
    }

    handleTagMenuOpen = (event) => {
        event.stopPropagation();
        this.setState({ tagMenuEl: event.currentTarget });
    };

    handleTagMenuClose = (event) => {
        this.setState({ tagMenuEl: null });
    };

    handleChangeTag = (_AValue) => {
        var { selected, target, onChange } = this.props;
        var AResponse = "";
        if (!_.isUndefined(selected) && !_.isNull(selected) && selected.length > 0) {
            if (this.isSelected(_AValue)) {
                selected.split(",").forEach(id => {
                    if (id !== _AValue) {
                        if (AResponse.length > 0) {
                            AResponse = AResponse + ",";
                        }
                        AResponse = AResponse + id;
                    }
                });
            }
            else {
                AResponse = selected + "," + _AValue;
            }
        }
        else {
            AResponse = AResponse + _AValue;
        }
        onChange({ target: { name: target, value: AResponse } });
    };

    isSelected = (_AValue) => {
        var { selected } = this.props;
        if (!_.isUndefined(selected) && !_.isNull(selected) && selected.length > 0) {
            if (selected.includes(_AValue)) {
                return true;
            }
        }
        return false;
    }

    render() {

        const { tagMenuEl } = this.state;
        const { xappRouteParams, tags, className, readOnly, selected, showSelected = true, refreshTags = null, tipo } = this.props;
        return (
            <React.Fragment>
                <div className={clsx(showSelected && "flex w-full")}>
                    <XAPPButton
                        tooltip={{ "title": "Tags", "placement": "top" }}
                        className={clsx("items-start max-h-48", className)}
                        ariaOwns={tagMenuEl ? 'label-menu' : null}
                        ariaHaspopup="true"
                        disabled={readOnly}
                        onClick={ev => this.handleTagMenuOpen(ev)}
                        icon={"label"}
                        type={"icon"}
                    />
                    <Menu
                        id="label-menu"
                        anchorEl={tagMenuEl}
                        open={Boolean(tagMenuEl)}
                        onClose={this.handleTagMenuClose}
                    >
                        {!_.isUndefined(tags) && !_.isNull(tags) && tags.map((tag) => (
                            <MenuItem
                                onClick={() => this.handleChangeTag(tag.codigo)}
                                key={"MenuItem_" + tag.codigo}
                            >
                                <ListItemIcon>
                                    <Icon className="mr-0" color="action">
                                        {this.isSelected(tag.codigo) ? 'check_box' : 'check_box_outline_blank'}
                                    </Icon>
                                </ListItemIcon>
                                <ListItemIcon>
                                    <MdLabel className="mr-0" style={{ color: tag.cor }} color="action" />
                                </ListItemIcon>
                                <ListItemText primary={tag.tagnome} disableTypography={true} />
                            </MenuItem>
                        ))}
                        {!_.isNull(refreshTags) &&
                            <EmpresaTagNewButton
                                xappRouteParams={xappRouteParams}
                                tipo={tipo}
                                callback={() => {
                                    refreshTags();
                                    this.handleTagMenuClose();
                                }}
                            >
                                <MenuItem
                                    onClick={() => { }}
                                    key={"MenuItem_NovaTag"}
                                >
                                    <ListItemIcon>
                                        <MdAdd className="mr-0 text-20" color="action" />
                                    </ListItemIcon>
                                    <ListItemText primary={"Adicionar tag"} disableTypography={true} />
                                </MenuItem>
                            </EmpresaTagNewButton>
                        }
                    </Menu>

                    {showSelected && !_.isUndefined(selected) && !_.isNull(selected) && selected.length > 0 && (
                        <div className={clsx("flex flex-wrap items-center", className)}>
                            {selected.split(",").map(id => {
                                if (showSelected) {
                                    var ATag = {};
                                    ATag = _.find(tags, { codigo: id });
                                    if (!_.isUndefined(ATag)) {
                                        if (!readOnly) {
                                            return (
                                                <Chip
                                                    avatar={(
                                                        <Avatar
                                                            classes={{ colorDefault: "bg-transparent" }}>
                                                            <MdLabel
                                                                className="text-20"
                                                                style={{ color: ATag ? ATag.cor : '' }}
                                                            />
                                                        </Avatar>
                                                    )}
                                                    label={ATag ? ATag.tagnome : ''}
                                                    onDelete={() => this.handleChangeTag(id)}
                                                    className="mr-8 mt-px"
                                                    classes={{ label: "pl-4" }}
                                                    key={"ChipTag_" + id}
                                                />
                                            )
                                        }
                                        else {
                                            return (
                                                <Chip
                                                    avatar={(
                                                        <Avatar
                                                            classes={{ colorDefault: "bg-transparent" }}>
                                                            <MdLabel
                                                                className="text-20"
                                                                style={{ color: ATag.cor }}
                                                            />
                                                        </Avatar>
                                                    )}
                                                    label={ATag.tagnome}
                                                    className="mr-8 mt-px"
                                                    classes={{ label: "pl-4" }}
                                                    key={"ChipTag_" + ATag.codigo}
                                                />
                                            )
                                        }
                                    }
                                }
                                else {
                                    return null;
                                }
                            })}
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

export default TagFormulario;
